import { render, staticRenderFns } from "./EventosPuntoVenta.vue?vue&type=template&id=065613fa&"
import script from "./EventosPuntoVenta.vue?vue&type=script&lang=js&"
export * from "./EventosPuntoVenta.vue?vue&type=script&lang=js&"
import style0 from "./EventosPuntoVenta.vue?vue&type=style&index=0&id=065613fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports